import { useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import { doMigration } from '../services'

const useMigration = () => {
  const { signedIn } = useUser()
  useEffect(() => {
    if (!signedIn) return
    doMigration()
  }, [signedIn])
}

export default useMigration
